import { ISystemType } from '@app/shared/services/system-type/system-type.interface';
import { Injectable } from '@angular/core';
import { UserGroup } from '@app/user-groups/user-group.model';

export const SystemType: { Concrete: ISystemType; Aggregate: ISystemType; Block: ISystemType } = {
  Concrete: { id: 1, name: 'Concrete', groupId: 1001 },
  Aggregate: { id: 2, name: 'Aggregate', groupId: 1002 },
  Block: { id: 3, name: 'Block', groupId: 1003 }
};

@Injectable({ providedIn: 'root' })
export class SystemTypeService {
  constructor() {}

  public getSystemTypesForUserGroups(userGroups: Array<UserGroup>): Array<ISystemType> {
    const userGroupIds = userGroups.map((userGroup) => userGroup.id);
    const systemTypesArray = Object.keys(SystemType).map((key) => SystemType[key]);

    return systemTypesArray.filter((systemType) => {
      return userGroupIds.indexOf(systemType.groupId) > -1;
    });
  }
}
